import React from 'react';

const RenderListItem = ({listText}) => {
    return (
        <li>{listText}</li>
    );
};

export default RenderListItem;